import "./App.scss";
import "./fonts/fonts.css";
//import "./styles/themes.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { store } from './redux/store';
import { createUserManager, OidcProvider, loadUser } from 'redux-oidc';
import { useGetTenantQuery } from "./redux/api/BaseApi";
import { useEffect, useState } from "react";
import { oAuthSettings } from "./components/Auth/AuthSettings";
import { Log } from "oidc-client-ts";
import { useReduxSelector } from "./redux/hooks";
import { RevelationContext } from "./context/RevelationContext";
import { NoApiServer, NoAuthServer } from "./components/ErrorPages/NoAuthServer";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import { AppRoutes } from "./components/Routes/AppRoutes";
import { Spinny } from "./components/Nav/Spinny";
import React from "react";
import SignoutPage from "./components/Auth/SignoutPage";
import { Constants } from "./Variables/StaticVariables";

const App = () => {
  const stateUser = useReduxSelector((state) => state.auth);
  const { data: tenant, isFetching, error: tenantNotFound } = useGetTenantQuery();
  const navigate = useNavigate();
  const [userManager, setUserManager] = useState(null)
  const [isAuthenticating, setAuthenticating] = useState(false)


  const signIn = async () => {
    let settings = oAuthSettings;
    if (tenant?.Authority)
      settings.authority = tenant?.Authority

    Log.setLevel(Log.DEBUG)
    let newUserManager = createUserManager(settings)
    let newUser = await newUserManager.getUser();

    console.log('signIn', newUser, tenant, tenantNotFound);


    //console.log('newUserManager.getUser', newUser);
    if (newUser == null || newUser.expired) {
      var returnUrl = window.location.pathname + window.location.search;
      console.log('newUserManager.signinRedirect', returnUrl)

      //This can take some time the first login, so show a spinner.
      setAuthenticating(true);
      await newUserManager.signinRedirect({ state: returnUrl })
        .then((user) => { console.log('after signinRedirect', user) })
        .catch((err) => {
          console.log('oops', err)
          navigate(`/error/noauth?authority=${tenant?.Authority || oAuthSettings.authority}`)
        });

      console.log('DONE newUserManager.signinRedirect')
      setAuthenticating(false);

      return;
    }
    else {
      await loadUser(store, newUserManager);   //Loads potentially existing user data into the redux store, thus eliminating a new authentication roundtrip to the authentication server when a tab is closed or a new tab is opened.
      //await newUserManager.storeUser(loadedUser);
      console.log('FINISHED loadUser', newUser, stateUser)

    }
    setUserManager(newUserManager);

    console.log('FINISHED newUserManager.signinRedirect')

  }

  const signOut = async () => {
    let settings = oAuthSettings;
    if (tenant?.Authority)
      settings.authority = tenant?.Authority

    let userManager = createUserManager(settings)
    await userManager.signoutRedirect({
      extraQueryParams: { logoutMessage: 'Session expired due to inactivity' },
    });
  }

  useEffect(() => {
    if (tenant || tenantNotFound) {

      //Don't sign in if tenant is not found,
      if (tenantNotFound) {
        navigate(`/error/noAPI?url=${Constants.apiRoot}`)
        return;
      }

      signIn().catch((err) => {
        console.log('oops', err)

        navigate(`/error/noauth?authority=${tenant?.Authority || oAuthSettings.authority}`)

      });

    }
  }, [tenant, tenantNotFound])


  console.log('App.tsx Authenticating?', userManager, stateUser, isAuthenticating, 'expires_In_min', stateUser?.user?.expires_in / 60, 'expire_date', new Date(new Date().getTime() + stateUser?.user?.expires_in * 1000))

  useEffect(() => {
    //user probably expoired, due to ideal tab, sign nout
    if (!stateUser?.user && !stateUser?.isLoadingUser) {
      //No blank screen
      //return <></>
      console.warn('App.tsx Redirecting to sign in', userManager, stateUser, isAuthenticating)
      //signOut();
      //Try sign in again
      // signIn().catch((err) => {
      //   console.warn('oops', err)
      // });
    }
  }, [stateUser])

  if (isAuthenticating) return <Spinny text="Authenticating...." />
  return (
    <>
      <Routes>
        {/* microfrontend test */}
        <Route path="/signout" element={<SignoutPage />} />
        <Route path="/error/noauth" element={<NoAuthServer />} />
        <Route path="/error/noapi" element={<NoApiServer />} />
        {userManager && <Route path="*" element={<OidcProvider store={store} userManager={userManager}>
          <RevelationContext>
            <AppRoutes />
            <ToastContainer />
          </RevelationContext>
        </OidcProvider>} />}
      </Routes>
    </>
  );
};

export default App;
